module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img513-8cc7eff455d8e772cd1a5bcec49b4390.jpg";